<template>
    <div id="rechargeB">
		<div class="header">
			<div class="logo">
				<img v-if="simInfo.flowRatePool=='联通'||simInfo.flowRatePool=='乐语'" src="./../../assets/cucc.png" alt="">
				<img v-else-if="simInfo.flowRatePool=='电信'" src="./../../assets/ctcc.png" alt="">
				<img v-else-if="simInfo.flowRatePool=='移动'||simInfo.flowRatePool=='移动接口'" src="./../../assets/cmcc.png" alt="">
				<img v-else src="./../../assets/kairan.jpg" alt="">
			</div>
			<div class="header-userInfo">
				<div class="iccid-line">{{ this.$store.state.recordLoginText }}	</div>
				<div class="el-status card-bg">在用套餐：{{simInfo.pkgName?simInfo.pkgName:'暂无套餐'}}</div>
			</div>
		</div>
        <div class="packagePanel">
            <div class="tabbar">
                <p :class="{'activeTab':tabbar==1}" @click="tabbarClick('1')">
					<span>基础套餐</span>
				</p>
                <p v-if="simData2.length > 0" :class="{'activeTab':tabbar==2}" @click="tabbarClick('2')">
					<span>加油套餐</span>
				</p>
                 <p v-if="simData3.length > 0" :class="{'activeTab':tabbar==3}" @click="tabbarClick('3')">
					<span>年包套餐</span>
				</p>
            </div>
			<van-row>
			  <van-col span="12" class="package" v-for="item in simData" :key="item.id" @click="changeState(item,'1')" v-show="tabbar==1">
				<div class="package-name" :class="{'overlay-package':item.type == 11, 'label-defined-active':indexActive==item.id}"> 
					<!-- <h1 style="color: #07c160;" v-if="item.type == 11 ">{{item.packageName}}</h1> -->
					<h1>{{item.packageName}}</h1>
                    <p>{{item.remark}}</p>
                    <p style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                        <p>{{item.dayRemarkInfo}}</p>
					<!-- <p v-if="item.type==11" style="color: #07c160;">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
					<p v-else-if="(item.type==2 || item.type == 10 ) && isNextMonth=='1'">
						有效期：{{firstDayOfNextMonth()}} 至 {{lastDayOfNextMonth()}}</p>
					<p v-else-if="(item.type==2 || item.type == 10 ) && isNextMonth=='0'">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
					 <p v-else-if="item.type==12">
						有效期：根据套餐结束时间叠加
					</p>
					  <p v-else-if="item.type==13">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}
					</p>
					 <p v-else-if="item.type==14||  item.type == 15|| item.type == 17">
						有效期： 每个月26号为一个核算周期
					</p>
					<p v-else-if="item.type!=2 && item.type!=4 && item.type!=3">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{afterManyDays(item.type==7?90:item.type==8?180:item.type==9?365:30)}}
					</p>
					<p v-if="item.type==12 ||item.type==6">月底不清0，套餐30天有效期，30天之内只能生效一次基础套餐，用完请订购加速包。</p>
					<p v-if="item.type==13">月底清0，基础套餐用完请购买加速包。</p>
                    <p v-if="item.type==2">基础套餐可无限叠加。</p> -->
					<p class="package-price">￥{{item.salePriceRmb}}元</p>
				</div>
				</van-col>
                <van-col span="12" class="package" v-for="item in simData2" :key="item.id" @click="changeState(item, 2)" v-show="tabbar==2">
					<!-- <span class="label-defined" :class="{'label-defined-active':indexActive2==item.id}">
						<label><van-icon name="success" color="#fff"/></label>
					</span> -->

					<div class="package-name" :class="{'label-defined-active':indexActive2==item.id}"> 
						<!-- <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13 || item.type == 18|| item.type == 16||item.type == 19">{{item.packageName}}</h1> -->
						<h1>{{item.packageName}}</h1>
						<!-- 生效时间 -->
                          <p>{{item.remark}}</p>
                          <p style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                        <p>{{item.dayRemarkInfo}}</p>
						<!-- <p v-if="item.type==11">
							有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
                        <p v-else >主套餐时间内无限叠加，加油包随基础套餐时间清零</p> -->
					
						<p class="package-price">￥{{item.salePriceRmb}}元</p>
					</div>
				</van-col>
				<van-col span="12" class="package2" v-for="item in simData3" :key="item.id" @click="changeState(item, 3)" v-show="tabbar==3">
					<span class="label-defined" >
                        多选包
                    </span>

					<div class="package-name" :class="{'label-defined-active':indexActive3==item.id}"> 
						<!-- <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13 || item.type == 18|| item.type == 16||item.type == 19">{{item.packageName}}</h1> -->
						<h1>{{item.packageName}}</h1>
						<!-- 生效时间 -->
                          <p>{{item.remark}}</p>
                          <p style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                          <p>{{item.dayRemarkInfo}}</p>
						<!-- <p v-if="item.type==11">
							有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
                        <p v-else >主套餐时间内无限叠加，加油包随基础套餐时间清零</p> -->
					
						<p class="package-price">￥{{item.salePriceRmb}}元</p>
					</div>
				</van-col>
			</van-row>
        </div>
        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
            :typeStyle="typeStyle"/>
        
        <div class="toRecharge">
             <p class="detail" v-if="isNaturalMonth && thisCucc==1" style="color: #FF6463;">每月22号后 请优先选择次月生效
                <!-- <span v-show='this.isNextMonth==0'>，<span style="color: #FF6463;">本月26号清零。</span></span>
                <span v-show='this.isNextMonth==1'>，<span style="color: #FF6463;">次月26号清零。</span></span> -->
            </p>
			<p class="detail" v-else-if="isNaturalMonth && isShowdetail">每月25号后 请优先选择次月生效
			    <!-- <span v-show='this.isNextMonth==0'>，月底清零。</span>
			    <span v-show='this.isNextMonth==1'>，次月月底清零。</span> -->
			</p>
            <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
                <van-radio-group v-model="isNextMonth" class="radio-group-defined">
                    <div>
                        <van-radio name="0" checked-color="#FF6463">本月生效</van-radio>
                    </div>
                    <div>
                        <van-radio name="1" checked-color="#FF6463">次月生效</van-radio>
                    </div>
                </van-radio-group>
            </div>
            <div class="toRecharge-bottom">
                <p>合计：<span>{{price}} 元</span></p>
                <div class="toRechargeBtn" @click="toRecharge()">订 购</div>
            </div>
        </div>

    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { Dialog } from 'vant';
import Checkstand from "@/components/Checkstand";
export default {
    components: {Checkstand},
    data(){
        return {
            indexActive: '',
            simData: [],
			simInfo:{},
            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
			
            isAdmin: '',
            globalIsAdmin: '',
			wxHeadImg: localStorage.getItem('wxHeadImg'),
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price:0,
            typeStyle: 1, //流量充值入口为1
            tabbar: 1,

            simData2: [],
            simData3:[],
            indexActive2: '',
            indexActive3:'',
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            },
            itemInfo3: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            },
            isShowdetail:false,
            thisCucc:0
        }
    },
    methods: {
        // changeState(item){            
        //     this.indexActive = item.id;
        //     this.itemInfo = item; 
        //     this.price = item.salePriceRmb;

        //     if(item.isAdmin!=null&&
        //         item.isAdmin!=undefined&&
        //         item.isAdmin==1){
        //         this.isAdmin = item.isAdmin;
        //     }else{
        //         this.isAdmin = this.globalIsAdmin;
        //     }

        //     this.isNaturalMonth = item.type == 2 || item.type == 10? true : false; 
        //     this.showMonthChoose = item.type == 2 ? true : false; 
        // },
        changeState(item, tabbar){
            if(tabbar == 1){
                this.indexActive = item.id;
                this.itemInfo = item; 
                this.price = item.salePriceRmb;
            }else if(tabbar == 2) {
                this.indexActive2 = item.id;
                this.itemInfo2 = item; 
                this.price = item.salePriceRmb;
            }else{
                this.indexActive3 = item.id;
                this.itemInfo3 = item; 
                this.price = item.salePriceRmb;
            }
            
            if(item.isAdmin!=null&&
                item.isAdmin!=undefined&&
                item.isAdmin==1){
                this.isAdmin = item.isAdmin;
            }else{
                this.isAdmin = this.globalIsAdmin;
            }

            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.showMonthChoose = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this. isShowdetail= item.type == 2 || item.type == 10? true : false; 
        },

        toRecharge(){
            this.showCheckstand=false;
            var iccids=localStorage.getItem('iccid');
            let _data = { iccid: iccids};

            let self = this;
            var pop = {                
                iccid: this.$store.state.iccid,
                pkgId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                isNextMonth: this.isNextMonth
            }
              //判断是否是月卡
            if(this.isNaturalMonth||this.showMonthChoose==true){
                pop.isNextMonth = this.isNextMonth;
            }else{
                pop.isNextMonth = '0';//万能卡
            }
            if(this.tabbar == 1){
                pop.pkgId=this.itemInfo.id
            }else if(this.tabbar == 2){
                pop.pkgId=this.itemInfo2.id
            }else if(this.tabbar == 3){
                pop.pkgId=this.itemInfo3.id
            }
             wxRequest("sim/activity/timer",pop, "post").then(res => {
                var result = res.data.data;
                if(res.data.code == 200){
                    Dialog.confirm({
                        title: "套餐生效提醒",
                        message: "生效时间："+res.data.data.start  +"<br/>到期时间："+res.data.data.end+"<br/>谨慎订购，误订不退款"
                    }).then(() => {
                        var data = {                
                            iccid: this.$store.state.iccid,
                            soldPackageId: this.itemInfo.id,
                            isAdmin: this.isAdmin,
                            salePriceRmb: this.itemInfo.salePriceRmb,
                        }
                        
                        let data2 = {                
                            iccid: this.$store.state.iccid,
                            soldPackageId: this.itemInfo2.id,
                            isAdmin: this.isAdmin,
                            salePriceRmb: this.itemInfo2.salePriceRmb,
                        }
                        let data3 = {                
                            iccid: this.$store.state.iccid,
                            soldPackageId: this.itemInfo3.id,
                            isAdmin: this.isAdmin,
                            salePriceRmb: this.itemInfo3.salePriceRmb,
                        }
                        //判断是否是月卡
                        if(this.isNaturalMonth){
                            data.isNextMonth = this.isNextMonth;
                        }else{
                            data.isNextMonth = '0';//万能卡
                        }

                        if(this.$store.state.source != false){
                            data.source = this.$store.state.source;
                        }else{
                            data.source = 'xxgzh';
                        }

                        this.$store.state.showCheckstand = true;
                        this.$store.state.showCheckstandSource = 'flowRecharge';
                        if(this.tabbar == 1){
                            this.dataToPay = data;
                        }else if(this.tabbar == 2) {
                            this.dataToPay = data2;
                        }else if(this.tabbar == 3) {
                            this.dataToPay = data3;
                        }                                         
                    }).catch(() => {});
                }else{
                    var data = {                
                        iccid: this.$store.state.iccid,
                        soldPackageId: this.itemInfo.id,
                        isAdmin: this.isAdmin,
                        salePriceRmb: this.itemInfo.salePriceRmb,
                    }

                    let data2 = {                
                        iccid: this.$store.state.iccid,
                        soldPackageId: this.itemInfo2.id,
                        isAdmin: this.isAdmin,
                        salePriceRmb: this.itemInfo2.salePriceRmb,
                    }
                    let data3 = {                
                        iccid: this.$store.state.iccid,
                        soldPackageId: this.itemInfo3.id,
                        isAdmin: this.isAdmin,
                        salePriceRmb: this.itemInfo3.salePriceRmb,
                    }
                    //判断是否是月卡
                    if(this.isNaturalMonth){
                        data.isNextMonth = this.isNextMonth;
                    }else{
                        data.isNextMonth = '0';//万能卡
                    }

                    if(this.$store.state.source != false){
                        data.source = this.$store.state.source;
                    }else{
                        data.source = 'xxgzh';
                    }
                    this.$store.state.showCheckstand = true;
                    this.$store.state.showCheckstandSource = 'flowRecharge';
                    if(this.tabbar == 1){
                        this.dataToPay = data;
                    }else if(this.tabbar == 2) {
                        this.dataToPay = data2;
                    }else if(this.tabbar == 3) {
                        this.dataToPay = data3;
                    } 
                }
            })
        },

        //第n天后
        afterManyDays(manyDays){
            let startTime = new Date();
            let startDate = new Date(startTime);
            startDate.setDate(startDate.getDate() + manyDays);
            return this.dateFormat('yyyy-MM-dd', startDate);
        },

        // 本月最后一天
        lastDayOfThisMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
        },

        //下个月第一天
        firstDayOfNextMonth(){
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();

            let date2 = new Date(year, month + 1, 1)
            return this.dateFormat('yyyy-MM-dd', new Date(date2));
        },
        // 下个月最后一天
        lastDayOfNextMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
        },

        changePayType(type){
            this.payType = type;
        },

        //点击tabbar
        tabbarClick(index){
            this.tabbar = index;
            if(this.simData.length != 0 && index == '1'){
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
				this.changeState(this.itemInfo,index)
            }else if(this.simData2.length != 0 && index == '2'){
                this.indexActive2 = this.simData2[0].id;
                this.price = this.simData2[0].salePriceRmb;
                this.itemInfo2 = this.simData2[0];
				this.changeState(this.itemInfo2,index)
            }else if(this.simData3.length != 0 && index == '3'){
                this.indexActive3 = this.simData3[0].id;
                this.price = this.simData3[0].salePriceRmb;
                this.itemInfo3 = this.simData3[0];
				this.changeState(this.itemInfo3,index)
            }
        }
    },
    created(){
		wxRequest("sim/detail", { iccid: this.$store.state.iccid	}, "post").then(res => {
			if (res.data.code == 200) {
				this.simInfo =  res.data.data;
			}
		})
        var data = {
            iccid: this.$store.state.iccid
        }
        wxRequest("sim/user/soldPkg/next/pkg", data, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200){
               Dialog.alert({
								title: '温馨提示',
								message:res.data.message
					})
            }
        })
        wxRequest("sim/user/soldPkg", data, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200 && result.list.length > 0){
                this.endTime = result.endTime;
                let resultArray1 = [];
                let resultArray2 = [];
                for(let i=0; i<result.list.length; i++){
                     console.log('当前type'+result.list[i].type);
                    if(result.list[i].type == 17||result.list[i].type == 14){
                        this.thisCucc=1
                    }

                    // if(result.list[i].type == 11 || result.list[i].type == 13){
                    //     resultArray1.push(result.list[i]);
                    // }else if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                    //     resultArray2.unshift(result.list[i]);
                    // }else {
                    //     resultArray1.unshift(result.list[i]);
                    // }
                    if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9 || ( result.list[i].type >= 28 && result.list[i].type <= 37)
                    || ( result.list[i].type >= 42 && result.list[i].type <= 48) || ( result.list[i].type >= 54 && result.list[i].type <= 57)){ //年包
                        this.simData3.push(result.list[i])
                        this.simData3.sort((b, a) => b.sort - a.sort);
                    }else if (result.list[i].type == 1 || result.list[i].type == 4 || result.list[i].type == 11 || result.list[i].type == 13 || result.list[i].type == 16 ||result.list[i].type == 18 ||result.list[i].type == 19){ //加油包
                        this.simData2.push(result.list[i])
                        this.simData2.sort((b, a) => b.sort - a.sort);
                    }else {
                        // if(result.list[i].packageName.includes('200')){
                        //     resultArray1.push(result.list[i])
                        // }else {
                        //     resultArray1.unshift(result.list[i])
                        // }
                        resultArray1.unshift(result.list[i])
                    }
                }
                    /**每月倒数第6天默认选中次月生效**/
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                console.log('当前日期'+day);
                console.log('当前cucc'+this.thisCucc);
                var date2 = new Date(year, month + 1, 0)
                var endDay = date2.getDate();
                if(this.thisCucc==0){
                    day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
                }else{
                    if(day>=21&&day<=26){
                        console.log('当前本月'+day);
                        this.isNextMonth ='1'
                    }else{
                        console.log('当前次月'+day);
                        this.isNextMonth= '0'
                    }
                }
                this.simData = resultArray1.concat(resultArray2);
                this.simData.sort((b, a) => b.sort - a.sort);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14|| this.simData[0].type == 6
                || this.simData[0].type == 25 || this.simData[0].type == 17? true : false; 
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
            }
        })

       
    }
}
</script>
<style lang="less" scoped>

#rechargeB {
    background: #F6F6F6;
	height: calc(100% - 104px);
	overflow: auto;
	position: relative;
    .header {
		color: #fff;
		height:232px;
		display: flex;
		position: relative;
		padding:20px;
		background-image: linear-gradient(#1946C4,#F6F6F6,#F6F6F6);
		.logo{
			width: 52px;
			height: 52px;
			margin-right: 10px;
			img{
				width: 52px;
				height: 52px;
				margin-bottom: 10px;
				border-radius: 35px;
				border: 2px solid #fff;
			}
		}
		.header-userInfo{
			padding-top: 8px;
			.iccid-line{
				display: inline-block;
				font-size:1.125rem;
				margin-bottom: 5px;
			}
			.el-status{
				font-size:0.75rem;
			}
		}
    } 

    
    .packagePanel {
		width:95%;
		margin:0 auto;
		background: #fff;
		position: absolute;
		top:16%;
		left: 0;
		right:0;
		border-radius:0.625rem;
        .tabbar{
            display: flex;
            height: 60px;
            margin-bottom: 10px;
            p {
                flex: 1;
                height: inherit;
                text-align: center;
				font-size:1.125rem;
				line-height:60px;
				background: #F2F3F8;
				color: #94959A;
				font-weight:600;
            }
			p:first-child{
				border-top-left-radius: 10px;
			}
			p:nth-child(2){
				border-top-right-radius: 10px;
			}
            .activeTab {
				line-height:60px;
				display: inline-block;
				color:#000000;
				background:#fff;
				height: 100%;
				display: inline-block;
				width: 100%;
            }
        }
        .package-title{
            padding: 10px 0px;
            color: #333;
            font-weight:bold;
        }
        .package2{
            padding: 10px 5px;
            position: relative;
            .label-defined{
                display: block;
                position: absolute;  
                width:50px;
                height:18px;
                font-size:13px;
                text-align:center;
                color:#fff;
                line-height:18px;
                border-top-left-radius:10px;
                border-bottom-right-radius:10px;
                background: -webkit-linear-gradient(left top, #FF8038 , #FF6463);
                background: -o-linear-gradient(bottom right, #FF8038, #FF6463); 
                background: -moz-linear-gradient(bottom right, #FF8038, #FF6463);
                background: linear-gradient(to bottom right, #FF8038 , #FF6463); 
                label{
                    position: absolute;
                    left: -14px;
                top: -12px;
                    background: transparent;
                } 
            }
            .package-name{
                flex-grow: 1;
                padding: 5px 10px;
                background: #FFF3EC;
				border-radius:10px;
				border: #EEEDED 1px solid;
                h1{
                    margin:14px 0;
                    color: #000;
					// height:40px;
                    font-size:1rem;
					font-weight:600;
					text-align: center;
					line-height:20px;
                }
                p{
                    margin: 10px 0;
                    color: #999999;
					line-height:20px;
					text-align: center;
                    font-size:12px;
                }
            }
			.label-defined-active{
			    background:#FFF3EC url(../../assets/home/icon18.png) no-repeat right bottom;
				background-size:35px 30px;
				border: #FF6463 1px solid;
			}

            p.package-price{
                flex-grow: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				color: #FF6463;
				font-weight: 600;
				font-size: 1rem;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
        }
        .package{
            // flex:1;
			padding: 10px 5px;
            position: relative;
			// height:10rem;
            .label-defined{
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;  

                label{
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                } 
            }
            .package-name{
                flex-grow: 1;
                padding: 5px 10px;
                background: #fff;
				border-radius:10px;
				border: #EEEDED 1px solid;
                h1{
                    margin:14px 0;
                    color: #000;
					// height:40px;
                    font-size:1rem;
					font-weight:600;
					text-align: center;
					line-height:20px;
                }
                p{
                    margin: 10px 0;
                    color: #999999;
					line-height:20px;
					text-align: center;
                    font-size:12px;
                }
            }
			.label-defined-active{
			    background: url(../../assets/home/icon15.png) no-repeat right bottom;
				background-size:35px 30px;
				border: #2351C7 1px solid;
			}

            p.package-price{
                flex-grow: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				color: #FF6463;
				font-weight: 600;
				font-size: 1rem;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
            
        }

    }

	


    .toRecharge{
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;
		background: #fff;
        .toRecharge-top{
            display: flex;
            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
				border-bottom: 1px solid #eee;
                height: 34px;
				/deep/.van-radio__icon--checked{
					.van-icon-success{
						background-color: #24BAC8 !important;
						border-color: #24BAC8 !important;
					}
				}
				/deep/.van-radio__label{
					color:#666;
					margin-left:0px
				}
                div{
                    height: 20px;
                    margin-right: 15px;
					.van-icon{
						font-size:12px;
					}
					&.van-radio__icon {
						margin-right: 0;
					}
                }
				span{
					font-size:0.75rem;
				}
            }

        }

        .detail {
            color: #96989D;
			font-size: 12px;
            padding-left: 20px;
            padding-top: 5px;
        }

        .toRecharge-bottom{
            display: flex;
			line-height:46px;
            p{
                padding-right: 15px;
                flex-grow: 1;
                color: #999;
                background:#fff;
				font-size: 0.75rem;
                text-align: left;
				line-height:46px;
				padding-left:10px;
                span{
                    color:#FF6463;
					font-weight: 600;
					font-size:1rem;
					vertical-align: middle;
                }
            }

            .toRechargeBtn{
                padding: 0 60px;
                display: inline-block;
                line-height: 46px;
                flex-grow: 0;
                color: #fff;
                background: #FF6463;
            }
        }

    }
}
</style>
